import { useState } from 'react';
import { LocalizedText, delay } from '@mews/framework';
import { Button } from '@optimus-web/core';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { BenefitsSection } from '../BenefitsSection';
import { CalculatorPanel } from '../CalculatorPanel';
import { ExtraFundingSection } from '../ExtraFundingSection';
import { FAQSection } from '../FAQSection';
import { MainSection } from '../MainSection';
import { RepaymentPlanSection } from '../RepaymentPlanSection';
import { NonEligibleUsers } from './NonEligibleUsers';

export const NonPrequalifiedUsers = () => {
    const [isChecking, setIsChecking] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const fakeEligibilityCheckRequest = async () => {
        setIsChecking(true);
        await delay(2000);
        setIsChecked(true);
        setIsChecking(false);
    };

    if (isChecked) {
        return <NonEligibleUsers />;
    }

    return (
        <>
            <MainSection isConsentTextShown={false}>
                <Button
                    onClick={fakeEligibilityCheckRequest}
                    size="large"
                    variant="primary"
                    data-test-id={DataTestId.CapitalCheckEligibilityButton}
                    disabled={isChecking}
                    type="submit"
                >
                    <LocalizedText textKey={TextKey.FinancialServicesCapitalButtonTextNonPrequalified} />
                </Button>
            </MainSection>
            <CalculatorPanel />
            <BenefitsSection />
            <RepaymentPlanSection />
            <ExtraFundingSection />
            <FAQSection />
        </>
    );
};
